import { forwardRef } from 'react';
import clsx from 'clsx';

export const Textarea = forwardRef(function Textarea({ label, error, hint, className, id, rows = 3, ...rest }, ref) {
  const inputId = id || rest.name || crypto.randomUUID();
  return (
    <div className="flex flex-col gap-1.5">
      {label && <label htmlFor={inputId} className="text-sm font-medium text-ink">{label}</label>}
      <textarea
        id={inputId}
        ref={ref}
        rows={rows}
        className={clsx(
          'rounded-md border bg-surface-elevated px-3 py-2 text-sm text-ink placeholder:text-ink-faint',
          error ? 'border-danger' : 'border-border focus:border-ink',
          'focus:outline-none',
          className
        )}
        {...rest}
      />
      {error ? <span className="text-xs text-danger">{error}</span> : hint ? <span className="text-xs text-ink-muted">{hint}</span> : null}
    </div>
  );
});
